export var CardBaseVariants;
(function (CardBaseVariants) {
    CardBaseVariants["default"] = "default";
    CardBaseVariants["primary"] = "primary";
    CardBaseVariants["secondary"] = "secondary";
})(CardBaseVariants || (CardBaseVariants = {}));
//# sourceMappingURL=constants.js.map